import React from 'react';

import { ShareThumbnailImage } from './thumbnail-image';
import { ShareThumbnailOverlay } from './overlay';

export const ShareThumbnail = ({ isNeueActive }: { isNeueActive: boolean }) => {
  return (
    <div className='flex flex-col space-y-sm py-6 border-b'>
      <div className='text-bedrock-p-strong text-bedrock-black'>Journey thumbnail</div>
      <div className='h-[175px] w-full bg-bedrock-light-gray rounded-lg relative group'>
        <ShareThumbnailImage />
        <ShareThumbnailOverlay isNeueActive={isNeueActive} />
      </div>
    </div>
  );
};
